/*
 * @Descripttion:  下单，订单查询
 * @version:
 * @Author: wlk
 * @Date: 2022-06-01 08:28:56
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-08-02 16:48:08
 */
import request from '../request'
enum Api {
  EXPRESSLIST = 'express/expressList',
  ORDER = 'sendParcel/batchPlaceOrder',
  CANCELORDER = 'sendParcel/cancelOrder',
  SENDDETAIL = 'sendParcel/detailSendParcel',
  PAGE = 'sendParcel/page',
  PRINTORDER = 'sendParcel/printOrder',
  YOYI = 'sendParcel/yoYiClientList',
  MONEY = 'sendParcel/batchTotalCostMoney',
  /* 导出 */
  EXPORT = 'export/exportSendParcel',
  IMPORTORDER = 'excel/import/order',

  EXPORT_ASYNC = 'order/exportAsync'
}

export default class makeOrderService {
  /**
   * 11111
   * @param data
   * @returns
   */
  static aaa(data: any): Promise<any> {
    return request.post('/enum/queryMap', data)
  }
  /**
   * 批量下单
   * @param data
   * @returns
   */
  static batchPlaceOrder(data: any): Promise<any> {
    return request.post(Api.ORDER, data)
  }
  /**
   * 取消面单
   * @param data
   * @returns
   */
  static cancelOrder(data: any): Promise<any> {
    return request.post(Api.CANCELORDER, data)
  }
  /**
   * 寄件详情
   * @param data
   * @returns
   */
  static detailSendParcel(data: any): Promise<any> {
    return request.post(Api.SENDDETAIL, data)
  }
  /**
   * 体积重量计算
   * @param data
   * @returns
   */
  /**
   * 寄件列表
   * @param data
   * @returns
   */
  static page(data: any): Promise<any> {
    return request.post(Api.PAGE, data)
  }
  /**
   * 打印面单
   * @param data
   * @returns
   */
  static printOrder(data: any): Promise<any> {
    return request.post(Api.PRINTORDER, data)
  }
  /**
   * YoYi客户列表模糊搜索
   * @param data
   * @returns
   */
  static yoYiClientList(data: any): Promise<any> {
    return request.post(Api.YOYI, data)
  }
  /**
   * 快递公司下拉
   * @param data
   * @returns
   */
  static expressList(data: any): Promise<any> {
    return request.post(Api.EXPRESSLIST, data)
  }
  /**
   * 批量计算报价
   * @param data
   * @returns
   */
  static batchTotalCostMoney(data: any): Promise<any> {
    return request.post(Api.MONEY, data)
  }
  /**
   * 订单列表导出
   * @param data any
   * @returns Promise
   */
  static getOrderExport(data: any): Promise<any> {
    return request.post(Api.EXPORT, data, true)
  }
  /**
   * 订单导入
   * @param data any
   * @returns Promise
   */
  static importOrder(data: any): Promise<any> {
    return request.post(Api.IMPORTORDER, data, true)
  }
  /**
   * 订单列表导出
   * @param data any
   * @returns Promise
   */
  static orderExportAsync(data: any): Promise<any> {
    return request.post(Api.EXPORT_ASYNC, data, true)
  }
}
